import { Box, Stack, Typography } from "@mui/material";

/**
 * The product header row shared by the overview, canceled and inactive cards
 * (r-1776): product icon, name with optional exclusivity label, a caption line
 * (price or description), and the product-specific actions on the right.
 */
export default function ProductPlanHeader({
  icon,
  iconSize = 36,
  title,
  exclusivity,
  caption,
  actions,
}: {
  icon: string;
  iconSize?: number;
  title: string;
  exclusivity?: string;
  caption: string;
  actions?: React.ReactNode;
}) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", md: "center" }}
      spacing={2}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <img
          loading="lazy"
          decoding="async"
          alt={title}
          src={icon}
          width={iconSize}
          height={iconSize}
        />
        <Box>
          <Stack direction="row" spacing={2} alignItems="baseline">
            <Typography variant="h6">{title}</Typography>
            {exclusivity ? (
              <Typography variant="body1" fontWeight={500}>
                {exclusivity}
              </Typography>
            ) : null}
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {caption}
          </Typography>
        </Box>
      </Stack>
      {actions}
    </Stack>
  );
}
